import { message } from 'antd';
import i18next from '../../i18next';

export function whenOrderIsCreated() {
  message.success({
    content: i18next.t('deliveryOtps.notifications.whenOrderIsCreated')
  });
}

export function whenOrderIsFailed(text?: string) {
  return message.error({
    content: `${i18next.t('deliveryOtps.notifications.whenOrderIsFailed')}: ${text || ''}`
  });
}
